<template>
  <header :class="{ shadow: shadow }">
    <div class="content content-width">
      <router-link to="/" class="logo">andreyrd</router-link>
      <transition name="nav" :duration="1000">
        <nav v-if="showNav">
          <router-link to="/experience">
            Experience
          </router-link>
          <router-link to="/projects">
            Projects
          </router-link>
          <!-- <router-link to="/services">
            Services
          </router-link> -->
          <router-link to="/skills">
            Skills
          </router-link>
        </nav>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  props: [ 'shadow' ],
  computed: {
    showNav () {
      return this.$route.name !== 'home';
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/sizes.scss';

header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 64px;
  transition: all 0.4s;
  z-index: 10;

  &.shadow {
    background: $color-bg-dim;
    border-bottom: 1px $color-border;;
    box-shadow: 1px 2px 10px rgba(black, 0.5);
    transition: all 0.2s;
  }
}

.content {
  position: relative;
  height: 100%;

  @include break-phone {
    margin-left: 8px;
    margin-right: 8px;
  }
}

nav {

  a { 
    display: inline-block;
    padding: 0 16px;
    color: white;
    font-size: 20px;
    line-height: 64px;
    text-decoration: none;
    transition: background 1s;

    @include break-phone {
      padding: 0 8px;
      font-size: 16px;
    }
  }

  a:hover {
    background: rgba($color-fg, 0.05);
  }

  a.router-link-active {
    background: rgba($color-fg, 0.2);
  }
}

.logo {
  position: absolute;
  top: 50%;
  right: 48px;
  transform: translateY(-50%);
  color: white;
  text-decoration: none;
  font-size: 32px;
  font-weight: bold;

  @include break-phone {
    right: 16px;
    font-size: 18px;
  }
}

.nav-enter-active, .nav-leave-active {

  a {
    transition: transform 0.5s;
  }

  a:nth-child(2) {
    transition-delay: 0.05s;
  }
}

.nav-enter-active {

  a {
    transition-delay: 0.2s;
  }

  a:nth-child(2) {
    transition-delay: 0.25s;
  }
}

.nav-enter, .nav-leave-to {
  
  a {
    transform: translateY(-64px);
  }
}
</style>
